import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  size?: 'md' | 'lg';
  label?: string;
};

export const PhoneFrame = ({ children, size = 'md', label }: Props) => (
  <div
    className={`phone${size === 'lg' ? ' phone--lg' : ''}`}
    role="img"
    aria-label={label ?? 'Prepzio mobile app preview'}
  >
    <div className="phone__screen">{children}</div>
  </div>
);
